import React, { useState, useEffect } from 'react';
import './styles.css';
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import { setSelectedItem } from '../../redux/actions/dashboardActions';
import { favoriteURL, bookcover,saveandremovefav,bookpath,serverurl} from '../../api/api';
import Pdfimg from '../../asset/images/pdf.png';
import Bookimg from '../../asset/images/book1.png';
import { Spin, Image,message, Button, Popover,Result } from 'antd';
import { DeleteOutlined,LoadingOutlined ,ReadOutlined, FilePdfOutlined, FilterOutlined,ShareAltOutlined} from '@ant-design/icons';
import Emptycard from '../../component/Empty';
import Space from '../../component/dashboard/space';
import Skeletonbook from '../../component/skeleton/skeletonbook';
import { RWebShare } from "react-web-share";
import Error500 from '../error/500';

const Favorite = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [favorite, setfavorite] = useState([])
    const [loading, setloading] = useState(true)
    const [favloading,setfavloading]=useState(false)
    const [usercredentials, setusercredentials] = useState({})
    const [contentid,setcontentid]=useState(0)
    const [error,setError]=useState(false)
    const isOnLine=localStorage.getItem('isonline')

    useEffect(() => {
        const lpp_userCredentials = JSON.parse(localStorage.getItem('lpp_userCredentials'));
        setusercredentials(lpp_userCredentials);
        console.log("lpp_userCredentials", lpp_userCredentials);
        getFavorite(lpp_userCredentials.apiKey);
    }, [])

    const getFavorite = async (apikey) => {
        console.log("apikey", apikey);
        let axios = require('axios');
        let config = {
            method: 'get',
            url: favoriteURL,
            headers: {
                'apikey': apikey
            }
        };
        axios(config)
            .then((response) => {
                setfavorite(response.data.data)
                setloading(false)
            })
            .catch(function (error) {
                setloading(false)
                setfavorite([])
                setError(true)


            });
    }
    const goTopdf = (item) => {
        dispatch(setSelectedItem(item));
        history.push('/pdf')
    }

    const goToepub = (item) => {
        dispatch(setSelectedItem(item));
        history.push('/reader')
    }

    const removeUserFav = (item) => {
        message.destroy("all")

        setfavloading(true)
        setcontentid(item.contentId)
        var myHeaders = new Headers();
        myHeaders.append("apikey", usercredentials.apikey);
        var formdata = new FormData();
        formdata.append("contentId", item.contentId);
        formdata.append("library", "0");
        formdata.append("path", bookpath+item.identifier);
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };
       fetch(saveandremovefav, requestOptions)
            .then(response => response.json())
            .then(result =>{
                console.log(result)
                 message.success('Book removed from your favorite list');
                 setfavloading(false)
                 getFavorite(usercredentials.apiKey);
                })
            .catch(error =>{
                setfavloading(false)

                 console.log('error', error)});
        }
        const goToDeacriton=(item)=>{
            history.push({pathname:'/book/isbn/'+ item.identifier,state:{contentid:item.contentId,fuzzyid:item.fuzzyId}})

        }
       
    
        const content = (item) => (
            <div>
                <p onClick={() => { goToepub(item) }}> <ReadOutlined style={{ fontSize: '15px', marginTop: '10px', color: 'blue', marginRight: '10px' }} />Epub</p>
                <p onClick={() => { goTopdf(item) }}> <FilePdfOutlined style={{ fontSize: '15px', marginTop: '10px', color: 'red', marginRight: '10px' }} />Pdf</p>
            </div>
        );
        if(isOnLine=="offline"){
            return(
                <div style={{display: 'flex', height:'50%', width: '100%', alignItems: "center", justifyContent: 'center',marginTop:'100px'}}>
            <Result
                status="500"
                title=""
                subTitle="You're offline.Explore downloads?"
                extra={<Button onClick={()=>props.setdownloade()} type="primary">Go to Downloads</Button>}/> 
            </div>
            )
          }
if(loading){
    return(  <Skeletonbook/>)
}
if(error){
    return(<Error500/>)
}

    if (favorite.length == 0) {
        return (
            <div style={{ display: 'flex', height: '90vh', width: '100%', alignItems: "center", justifyContent: 'center' }}>
                   <Emptycard  descriptin="You don't have any Favorite list" link={()=>{props.setsub()}}/>
                  
            </div>
          

        )
    }
    return (
        <div className="cards-container">
        {favorite.map((item) => {
             return (
                   <div  className="ion-card" >
                        <div className="bookcover_continer" >
                            <Image  className="bookcover"
                                fallback="data:image/png;base64,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"
                                src={bookcover + item.fuzzyId + "/"+item.cover}/>
                        </div>
                        <div className="bookcontent">
                            
                            <div onClick={() => { goToDeacriton(item) }}>
                            <div className="booktitle" >{item.title}</div>
                            <div className='card-sub'>{item.subTitle}</div>
                                <div className='card-auth'>{item.authors.map(item => item.surName+" "+item.givenName).toString().replaceAll(",", ", ")}</div>
                                <div className='card-dotdiv'><span> <span className='dot'></span>{item.type}</span>{item.pages && <span> <span className='dot'></span>{"Pages: "+item.pages}</span>}{item.pubYear &&<span> <span className='dot'></span>{"Year: "+item.pubYear}</span>}</div>
                                </div>
                                <div className='card-sharerevo'><RWebShare
                                    data={{
                                        text: item.title,
                                        url: serverurl + "book/isbn/" + item.identifier,
                                        title: "Share",
                                    }}
                                    onClick={() => console.log("shared successfully!")}>
                                    <p><ShareAltOutlined className="shareicon" />Share</p></RWebShare> 
                                    <div onClick={()=>removeUserFav(item)} className='removesect'>{favloading && contentid == item.contentId?<LoadingOutlined className='favrem-icon'  style={{color: "#0E89F0"}}/> :<DeleteOutlined className='favrem-icon' />}Remove</div>
                                    </div>

                            
                            
                        </div>
                    </div>
                 
                )
            })}
        <Space hig="10px" color="#ffffff" />

    </div>
      
    )
}

export default Favorite;